module.exports = __webpack_public_path__ + "img/logo-top.aa41ad81.png";